import React from "react";
import ExperienceStyles from "./IntrestedContainer.module.css";
import MongoDB from "../svg/mongodb.svg";
import Git from "../svg/git.svg";
import Python from "../svg/python.svg"
import Azure from "../svg/azure.svg"
import Docker from "../svg/docker.svg"
import Jupyter from "../svg/jupyter.svg"
import Pandas from "../svg/pandas.svg"
import Numpy from "../svg/numpy.svg"
import Postgre from "../svg/postgre.svg"
import MySQL from "../svg/sql.svg"
import VSCode from "../svg/vscode.svg"
import Anaconda from "../svg/anaconda.svg"
import Tableu from "../svg/tabelu.svg"
import Github from "../svg/github.svg"


const IntrestedContainer = () => {
  const Experiences = [
    {
      id: 1,
      imagesSvg: Python,
    },
    {
      id: 2,
      imagesSvg: Azure,
    },
    {
      id: 3,
      imagesSvg: Docker,
    },
    {
      id: 4,
      imagesSvg: MongoDB,
    },
    {
      id: 5,
      imagesSvg: Git,
    },
    {
      id: 6,
      imagesSvg: Jupyter,
    },
    {
      id: 7,
      imagesSvg: Numpy,
    },
    {
      id: 8,
      imagesSvg: Pandas,
    },
    {
      id: 9,
      imagesSvg: MySQL,
    },
    {
      id: 10,
      imagesSvg: Postgre,
    },
    {
      id: 11,
      imagesSvg: VSCode,
    },
    {
      id: 12,
      imagesSvg: Anaconda,
    },
    {
      id: 13,
      imagesSvg: Tableu,
    },
    {
      id: 14,
      imagesSvg: Github,
    },
    // {
    //   id: 15,
    //   imagesSvg: AdobeXD,
    // }
  ];

  return (
    <section className={ExperienceStyles.ExperienceContainer}>
      <div className={ExperienceStyles.ExperienceContent}>
        <h2>Tools Expertise</h2>
        <h5>
          Here you will discover additional details regarding my professional activities, and my current proficiency, mainly in
          programming and technology.
        </h5>
      </div>
      <div className={ExperienceStyles.ExperienceContainer_Image}>
      {Experiences.map(({ id, imagesSvg }) => {
        return (
          <div key={id} className={ExperienceStyles.ExperienceImage}>
            <img src={imagesSvg} alt="" />
          </div>
        );
      })}
      </div>
    </section>
  );
};

export default IntrestedContainer;
